// antd
import { Divider, Row, Typography, theme } from 'antd'

function ModelHeader({
    selectedDataProfile,
    modalTitle,
    showTitle,
    handleCancel,
    icon,
    description,
    modalKey,
}) {
    const { useToken } = theme
    const { token } = useToken()

    const { Title, Text } = Typography

    return (
        <>
            <Row
                justify={'space-between'}
                align={'middle'}
                style={{
                    padding: '20px 24px 15px 24px',
                    // boxShadow: '0px 4px 15px 0px #0000000d',
                }}
            >
                <Row
                    align={'middle'}
                    style={{
                        columnGap: '20px',
                    }}
                >
                    {/* <Row
                        style={{
                            height: '45px',
                            width: '45px',
                            borderRadius: '10px',
                            padding: '12px',
                            backgroundColor:
                                token.colorPalette.baseColor.tertiary,
                        }}
                        align={'middle'}
                        justify={'center'}
                    >
                        <div
                            style={{
                                alignItems: 'center',
                                justifyContent: 'center',
                                fill: 'red',
                            }}
                        >
                            {icon}
                        </div>
                    </Row> */}
                    <div>
                        <Title
                            className={'titleMiddle'}
                            style={{ textTransform: 'capitalize', fontSize: "20px" }}
                        >
                            {modalKey === 'viewVideo'
                                ? `View ${showTitle}`
                                : selectedDataProfile || showTitle === 'profile'
                                    ? `Edit ${showTitle}`
                                    : `Add ${showTitle}`}
                        </Title>
                        <Text
                            className="titleSecondary"
                            style={{
                                fontSize: token.fontSizeHeading5,
                            }}
                        >
                            {description}
                        </Text>
                    </div>
                </Row>
                {/* <div
                    onClick={() => handleCancel()}
                    style={{
                        cursor: 'pointer',
                        height: '30px',
                        width: '30px',
                    }}
                >
                    <CloseModalIcon />
                </div> */}
            </Row>
            <Divider style={{ margin: "0px" }} />
        </>
    )
}

export default ModelHeader
